import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

const News: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 12px) ',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'primary.main',
      }}
    >
      <Typography variant='h4' sx={{ textAlign: 'center' }}>
        {t('news.welcome', 'Welcome')}
      </Typography>
    </Box>
  );
};

export default News;
